
/**
 * api接口统一管理
 */
import {axiosInstance} from "./http";

export const dictionary = (obj) => axiosInstance.get('/blade-system/dict-biz/dictionary',{params:obj})//获取首页数据
//获取行政区划
export const regionTree = (obj) => axiosInstance.get('/blade-system/region/lazy-tree',{params:obj})

export const dictDetail = (obj) => axiosInstance.get('/blade-system/dict-biz/detail',{params:obj})

//通知公告列表
export const noticeList = obj => axiosInstance.get('blade-desk/notice/portalList',{params:obj})
//通知公告详情
export const noticeDetail = obj => axiosInstance.get('blade-desk/notice/detail',{params:obj})

//消息列表
export const messageList = obj => axiosInstance.get('/blade-stationMessage/stationmessage/getMyList',{params:obj})

export const messageCount = obj => axiosInstance.get('/blade-stationMessage/stationmessage/getMyCount',{params:obj})

export const updateMsgStatus = obj => axiosInstance.post('/blade-stationMessage/stationmessage/update',obj)












